import React, { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { RouterConfig } from "./Navigation/RouterConfig";
import { ProvideAuth, useAuth } from "./Navigation/Auth/ProvideAuth";
import { DynamicLoad } from "./assets";
import "../src/assets/fonts/INTROBOLD.OTF";
import "../src/assets/fonts/SourceSansPro-Bold.OTF";
import "../src/assets/fonts/SourceSansPro-Light.TTF";
import "../src/assets/fonts/SourceSansPro-Regular.OTF";
function App() {
  let auth = useAuth();
  return (
    <ProvideAuth>
      <BrowserRouter>
        <RouterConfig />
      </BrowserRouter>
    </ProvideAuth>
  );
}

export default App;
